import { Injectable } from '@angular/core';
import { TStoreAddAttachments } from '../../items-attachments/items-attachments.interface';
import { EItemRecurrenceEditType } from './apply-changes-recursively-question-modal.interface';

@Injectable()
export class RecurringItemService {
  public getStartDateForAttachmentRecurringUpdate(
    selectedRecurrenceEditType: EItemRecurrenceEditType,
    dueDate: string | null,
  ): Pick<TStoreAddAttachments, 'startDateForRecurringUpdate'> {
    switch (selectedRecurrenceEditType) {
      case EItemRecurrenceEditType.onlyThis:
        return {};
      case EItemRecurrenceEditType.thisAndFollowing:
        return { startDateForRecurringUpdate: dueDate };
      case EItemRecurrenceEditType.all:
        return { startDateForRecurringUpdate: null };
    }
  }
}
